/**
 * Delay the start of the word scrolling animation
 */
function digitalDelayScrollWordStart() {
  // Get all scrollers withing dig graphic
  const taglineScrollers = document.querySelectorAll(
    '.hero__dig-graphic .hero__tagline-scroller'
  );

  taglineScrollers.forEach((el) => {
    // Get delay value from attr, default to 2000
    const delay = el.dataset.initDelay ?? '2000';

    // Pause anim immediately
    el.classList.add('hero__tagline-scroller--paused');

    // Un-pause after delay
    setTimeout(function () {
      el.classList.remove('hero__tagline-scroller--paused');
    }, delay);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  digitalDelayScrollWordStart();
});
